
















import firebase from 'firebase'
import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import { includes } from 'ramda'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import { db } from '../../firebase/init'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import { RequestOffType } from '../../types'
import LocationStore from '../../store/modules/location'

@Component({
  // firestore() {
  //   return {
  //     allNotes: db.collection('userNotes'),
  //   }
  // },
  components: {
  },
})
export default class ViewRequestOff extends Mixins(MainMixin) {
  @Prop() request!:RequestOffType|null

  @Prop({ default: false }) outlined!:boolean

  @Prop({ default: false }) tile!:boolean

  @Prop({ default: false }) viewManager!:boolean

  get start() {
    if (!this.request || !this.request.start) return ''
    return dayjs(this.request.start).format('ddd, MMM D, YYYY')
  }

  get end() {
    if (!this.request || !this.request.end) return ''
    return dayjs(this.request.end).format('ddd, MMM D, YYYY')
  }
}
